import { useTranslation } from "@impero-com/common/utils/i18n";
import { Tag, TagVariant } from "@impero-com/ui";

import { Friction, FrictionData } from "api/generated/model";

import { HEALTH_LABEL_SEPARATOR, buildHealthLabels } from "../utils/health";

interface ControlActivityHealthTagProps {
    frictionData: FrictionData;
}

export function ControlActivityHealthTag({
    frictionData,
}: ControlActivityHealthTagProps) {
    const { t } = useTranslation();

    return (
        <Tag variant={HEALTH_VARIANTS[frictionData.friction]}>
            {buildHealthLabels(frictionData, t).join(HEALTH_LABEL_SEPARATOR)}
        </Tag>
    );
}

const HEALTH_VARIANTS: Record<Friction, TagVariant> = {
    [Friction.NoFriction]: "lightCyan",
    [Friction.Friction]: "cyan",
    [Friction.HighFriction]: "darkCyan",
};
